import commonHandler, {
  ResponseOrError,
} from '../../errorHandlers/common-handler';
import { Dispatch } from 'redux';
import { StoreState } from '../../store-interfaces';
import { ErrorReportingUtils } from '@mm/plugins';
import { UNAUTHORIZED } from '@mm/constants/status-codes';

const onboardingErrorHandler =
  (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, customMessage?: string) => {
    const sentryMessage = customMessage || 'Onboarding Error';
    const unauthorizedResponse =
      error instanceof Response && error.status === UNAUTHORIZED;

    if (!unauthorizedResponse) {
      ErrorReportingUtils.reportError(sentryMessage, { extraData: { error } });
    }

    commonHandler(dispatch)(error);
  };

export default onboardingErrorHandler;
